import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import './InputText.scss'

export const INPUT_TEXT_VARIANT_DANGER = 'danger'

export const InputText = ({
  placeholder,
  className,
  disabled,
  value,
  defaultValue,
  variant,
  onChange,
  onBlur,
  name,
  id,
  onKeyUp,
  onKeyDown,
  'data-mu-test': dataAttributeTest,
  ...otherProps
}) => {
  const inputName = name && `input-${name}`
  const inputId = id || inputName

  return (
    <span
      className={classnames('e-input-text', className, {
        'e-input-text--disabled': disabled,
        'e-input-text--danger': variant === INPUT_TEXT_VARIANT_DANGER
      })}
    >
      <input
        type='text'
        className='e-input-text__input'
        disabled={disabled}
        placeholder={placeholder}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        onBlur={onBlur}
        onKeyUp={onKeyUp}
        onKeyDown={onKeyDown}
        name={inputName}
        id={inputId}
        data-mu-test={classnames('input', dataAttributeTest)}
        {...otherProps}
      />
    </span>
  )
}

InputText.propTypes = {
  disabled: PropTypes.bool,
  className: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  onKeyUp: PropTypes.func,
  onKeyDown: PropTypes.func,
  onBlur: PropTypes.func,
  variant: PropTypes.oneOf([INPUT_TEXT_VARIANT_DANGER, '', null, undefined]),
  /**
   * Additional values for data-attribute used for tests and tracking
   **/
  'data-mu-test': PropTypes.string
}
